export const baseUrl = () => {
  return process.env.REACT_APP_THEFUTUR_BACKEND_BASE_URL
}
